module.exports = __webpack_public_path__ + "6bbb9be48b3b1e9139e6ec50ba719ffc.png";